import React from "react";
import Select from "react-select";
import {isMobile} from "react-device-detect";
import {MultipleSelectModal} from "../../PrettySelect/MultipleSelectModal";
import { useTranslations } from 'next-intl'

const RoomSelect = ({ id, name, handleSelectedItems, isHomePage, onChange, disabled, addEstate, value }: any) => {
    const t = useTranslations('')
    if (value) {
        if (!Array.isArray(value)) {
            value = [value.min.toString()]
        }
    } else {
        value = []
    }
    const transformedData = [
        {
            value: "1",
            label: "1"
        },
        {
            value: "2",
            label: "2"
        },
        {
            value: "3",
            label: "3"
        },
        {
            value: "4",
            label: "4+"
        }
    ]

    return (
        <div className="mb-3">
            {(!isHomePage && !addEstate) &&
              <label htmlFor={id} className="form-label">{name}</label>
            }

            {(!isMobile || !isHomePage) &&
                <Select
                    value={
                        transformedData.filter(option => {
                            return value.includes(option.value);
                        })
                    }
                    onChange={onChange}
                    options={transformedData}
                    isDisabled={disabled}
                    placeholder={t('Number of rooms')}
                    name={id}
                    id={id}
                    isMulti={true}
                    closeMenuOnSelect={false}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: '#e8e8e8',
                            fontSize: '14px',
                            color: '#212529',
                            borderRadius: '8px',
                        }),
                        multiValue: (styles, {data}) => {
                            return {
                                ...styles,
                                borderRadius: '12px',
                                fontSize: '13px'
                            };
                        },

                        multiValueRemove: (styles, {data}) => ({
                            ...styles,
                            ':hover': {
                                backgroundColor: 'inherit',
                                borderRadius: '12px',
                                color: 'white',
                            },
                        }),
                    }}
                />
            }

            {(isMobile && isHomePage) &&
                <MultipleSelectModal options={transformedData}
                                     name={id}
                                     placeholder={name}
                                     onSelectionApply={handleSelectedItems}/>
            }
        </div>
    )
};

export default RoomSelect;
